const like = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M3.654 6.454V15H.5V6.376h3.154zm10.256-.078c.317.028.62.137.884.315.543.345.81.996.668 1.624l-1.336 5.316A1.514 1.514 0 0 1 12.613 15H5.717a.983.983 0 0 1-.983-.847V6.632c.187-.306.354-.6.53-.906.384-.68 2.486-4.007 2.486-4.007a.562.562 0 0 1 .07-.128A1.297 1.297 0 0 1 8.87 1c.511-.008.971.307 1.15.787.103.29.103.606 0 .896l-.855 2.953a.473.473 0 0 0 0 .493.589.589 0 0 0 .54.226h4.205z"/></svg>',
};

export { like as default };
